import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../Tooltip/Tooltip.jsx';
import {
  ShareLink,
  ShareComponent,
  InputWrapper,
  CopyLink,
  ShareInput,
} from '../StyledComponents';

const shareUrl = (tileOrigin, tile) => {
  if (tileOrigin === 'explore') {
    return tile.exploreSharePath;
  }
  return tile.sharablePath;
};

const ShareTileComponent = ({ tile, tileOrigin }) => {
  const [copyLinkClicked, setCopyLinkClicked] = useState(false);
  const { t } = useTranslation('tiles');
  const tooltipContent = copyLinkClicked
    ? t('shareTileComponent.copied')
    : t('shareTileComponent.clickToCopy');
  return (
    <ShareComponent className="tile-social-share-component">
      <Tooltip
        id="copyLink"
        getContent={() => tooltipContent}
        afterHide={() => setCopyLinkClicked(false)}
      />
      <ShareLink>{t('shareTileComponent.shareLink')}</ShareLink>
      <div
        style={{ padding: '0px 24px 16px 24px' }}
        className="share_link_block copy-to-clipboard-input-group"
      >
        <InputWrapper>
          <ShareInput
            type="text"
            name="share_tile_link"
            id="share_link"
            value={shareUrl(tileOrigin, tile)}
            readOnly
          />
          <CopyLink
            data-for="copyLink"
            data-tip
            className="js-copy-to-clipboard-btn"
            data-clipboard-target="#share_link"
            onClick={() => setCopyLinkClicked(true)}
          >
            {t('shareTileComponent.copyLink')}
          </CopyLink>
        </InputWrapper>
      </div>
    </ShareComponent>
  );
};

export default ShareTileComponent;
